// extracted by mini-css-extract-plugin
module.exports = {"box":"BorderedResponsiveVideo_box__2RK2a","footNote":"BorderedResponsiveVideo_footNote__2CwWe"};